






import { Component, Vue } from 'vue-property-decorator';
import ThemeWrapper from '@/components/Layout/ThemeWrapper.vue';

@Component({
  components: {
    ThemeWrapper
  }
})
export default class App extends Vue {}
